import React, { useState, useEffect } from "react";
import { getDocs, collection } from "firebase/firestore";
import { db } from "../../firebase";
import Showstu from "./Showstu";
import CompanySelected from "./CompanySelected";
import JobDesc from "./JobDesc";
import { useLocation } from "react-router-dom";
// import { CSVLink } from "react-csv";
import ReactHtmlTableToExcel from "react-html-table-to-excel";
import "./tnp.css";
import Tnpnav from "./Tnpnav";
export default function Sortedbydepart() {
  const [joblist, setJoblist] = useState([]);
  const location = useLocation();
  const { departments } = location.state;
  const ref = collection(db, "selected");
  const apply = async (id) => {};
  useEffect(() => {
    const getjob = async () => {
      const data = await getDocs(ref);
      setJoblist(data.docs.map((doc) => ({ ...doc.data(), id: doc.id })));
    };
    getjob();
  }, []);
  
  
  console.log(joblist);
  return (
    <>
        <Tnpnav/>
      <div className="container d-flex align-items-center justify-content-between ">
        <h1 className="logo titletnp">
          <p>
            BACTH 2021-22 PLACEMENT REPORT<span></span>
          </p>
        </h1>
        {/* <div c
lassName="Info-btn">
          <button className="btn w-30 btn-submit pr">SE-1</button>
        </div> */}

        <div className="Info-btn">
        <ReactHtmlTableToExcel
          className="btn w-30 btn-submit pr"
          table="stuTable"
          filename="Excel file"
          sheet="sheet"
          buttonText="Export to excel"
        />
      </div>
      </div>
      
      {/* <button className="tnpbutton">
        Click here to get the report in Excel Sheet
      </button> */}
      <table className="tnptable" id="stuTable">
        <thead>
          <tr>
  
            <th>Student name</th>
            <th>Student Email</th>
            <th>Student ID</th>
            <th>Class</th>
            <th>Department</th>
            <th>Roll no.</th>
            <th>Placed in</th>
            <th>Postion</th>
            <th>Package</th>
          </tr>
        </thead>
        
        {
        
        joblist.map((post, i) => {
          return (
            <>
              {post.position.map((val, j) => {
                if((val.department)===departments){
                  return (
                    <>
                      <tbody>
                        <tr>
                          <Showstu stuid={val.stuid} />
                          <CompanySelected cid={val.cid} />
                          <JobDesc postid={val.postid} cid={val.cid} />
                        </tr>
                      </tbody>
                    </>
                  );
                }
                }
               )}
            </>
          );
        })}
      </table>
     
      {/* <CSVLink {...CSVReport}>Export to CSV</CSVLink> */}
    </>
  );
}
